<template>
    <section class="SearchContainer">
        <el-row class="show-and-reset-filter">
            <el-col>
                <div>
                    <el-link @click="showSearch = false" v-if="showSearch">
                        {{ $t("components.searchContainer.hideFilters") }}
                        <em class="el-icon-arrow-up"/>
                    </el-link>
                    <el-link @click="showSearch = true" v-else>
                        <span style="text-transform: uppercase">
                          <strong>
                            {{ $t("components.searchContainer.showFilters") }}
                          </strong>
                        </span>
                        <em class="el-icon-arrow-down"/>
                    </el-link>
                </div>
            </el-col>
            <el-col>
                <div v-if="showSearch" class="div-reset-filter">
                    <!-- Si on a des filtres differents de ceux par défaut dans le store alors on affiche qu'il y a un filtre présent -->
                    <el-link @click="replaceFilter">{{ $t("general.filters.resetFilters") }}</el-link>
                </div>
                <div v-else>
                    <!--                    <span v-if="filter !== defaultFilter">Différent</span>-->
                </div>
            </el-col>
        </el-row>

        <div v-show="showSearch" style="margin-top: 10px">
            <div class="SearchContainer-main">
                <slot></slot>
                <el-button native-type="submit" type="danger">
                    {{ $t("components.searchContainer.search") }}

                </el-button>
            </div>
            <div v-if="filters" class="SearchContainer-filters">
                <br/>
                <el-radio-group v-model="filtersRadio">
                    <template v-for="({ value, label }, index) in filters">
                        <el-divider
                                direction="vertical"
                                :key="index + '-divider'"
                                v-if="index > 0"
                        />
                        <el-radio class="SearchContainer-filter" :label="label" :value="value"
                                  @change="$emit('filter', value)"></el-radio>
                        <!--          <el-button-->
                        <!--            class="SearchContainer-filter el-button&#45;&#45;text&#45;&#45;danger"-->
                        <!--            type="text"-->
                        <!--            v-text="label"-->
                        <!--            :key="value"-->
                        <!--            @click="$emit('filter', value)"-->
                        <!--          />-->
                    </template>
                </el-radio-group>
            </div>
            <el-collapse
                    class="SearchContainer-more"
                    v-if="$slots.more"
                    accordion
                    :value="moreOpened ? 'advanced' : null"
                    @change="item => $emit('update:more-opened', item === 'advanced')"
            >
                <el-collapse-item name="advanced" :title="$t('components.searchContainer.advancedSearch')">
                    <slot name="more"></slot>
                </el-collapse-item>
            </el-collapse>
        </div>

    </section>
</template>

<script>
import { Collapse, CollapseItem, Divider } from 'element-ui'
import { mapMutations } from 'vuex'

/**
     * Conteneur pour la recherche d'éléments
     */
export default {
  name: 'UbiSearchContainer',
  props: {
    /**
             * Indique si le filtre est effectué en temps réel (et masque le bouton Rechercher)
             */
    realtime: Boolean,
    /**
             * Indique si le panneau de recherche avancée est ouvert par défaut
             */
    moreOpened: Boolean,
    /**
             * Liste des filtres
             */
    filters: Array,
    defaultFilter: String
  },
  watch: {
    defaultFilter: function (newFilter) {
      const obj = this.filters.find(o => o.value === newFilter)
      if (obj) {
        this.filtersRadio = obj.label
        const valueToEmit = obj.value
        this.$emit('filter', valueToEmit)
      } else {
        this.filtersRadio = this.filters[0].label
      }
    }
  },
  data () {
    return {
      showSearch: false,
      filtersRadio: null,
      defaultRadio: null
    }
  },
  computed: {
  },
  methods: {
    setDefaultFilter (value) {
      this.defaultFilter = value
    },
    async replaceFilter () {
      // this.filtersRadio = this.defaultRadio;
      // this.defaultFilter = this.defaultRadio;
      this.$emit('resetfilter')
    }
  },
  components: {
    ElCollapse: Collapse,
    ElCollapseItem: CollapseItem,
    ElDivider: Divider

  },
  beforeMount () {
    this.filtersRadio = null
    this.defaultRadio = this.defaultValue

    if (!this.filters || this.filters.length === 0) {
      return
    }

    let valueToEmit = this.filters[0].value

    if (this.defaultFilter) {
      const obj = this.filters.find(o => o.value === this.defaultFilter)
      if (obj && obj.label) {
        this.filtersRadio = obj.label
        valueToEmit = obj.value
      } else {
        this.filtersRadio = this.filters[0].label
      }
    } else {
      this.filtersRadio = this.filters[0].label
    }

    this.$emit('filter', valueToEmit)
  }
}
</script>

<style lang="scss">
    @import "@/theme/_bootstrap.scss";

    .SearchContainer {
        &-main {
            > *:not(:last-child) {
                @extend .mr-4;

                &:first-child {
                    flex: 1;
                }
            }
        }

        &-filters {
            @extend .py-2;
            font-size: $font-size-sm;

            .el-button {
                font-size: $font-size-sm-alt;
            }
        }

        .el-checkbox {
            align-items: center;
            display: flex;
            height: 40px;
            justify-content: center;
            line-height: 40px;
            margin-bottom: 0;
        }

      .show-and-reset-filter {
        display: flex;
        justify-content: space-between;
        .div-reset-filter{
          text-align: end;
        }
      }

      &-prepend {
            @extend .mr-3;
        }

        &-filter {
            @extend .py-0;
        }

        &-more {
            &,
            .el-collapse-item__header,
            .el-collapse-item__wrap {
                @extend .border-0;
            }

            .el-collapse-item__header {
                @extend .text-primary;
                font-size: $font-size-base;

                display: flex;
                flex-direction: row-reverse;
                justify-content: flex-end;
                align-items: center;

                .el-collapse-item__arrow {
                    @extend .ml-0;
                }
            }
        }

        @include media-breakpoint-up(lg) {
            &-main {
                display: flex;
                align-items: flex-end;
                justify-content: space-between;

                .FormItem {
                    padding-bottom: 0 !important;
                }
            }
        }

        @include media-breakpoint-down(sm) {
            &-prepend {
                display: block;
                margin-bottom: map-get($spacers, 1) !important;
            }
            &-filters {
                margin-top: map-get($spacers, 2) !important;

                .el-divider {
                    display: none;
                }
            }
            &-filter {
                display: block;
                margin-bottom: map-get($spacers, 2) !important;
                margin-left: map-get($spacers, 2) !important;
            }

            &-main {
                > *:not(:last-child) {
                    margin-right: 0 !important;
                }
            }
        }
    }
</style>

<docs>
    ### Exemples

    ```javascript
    <ubi-panel style="background-color: #EBF3F2;">
        <ubi-search-container>
            <el-form-item label="Recherche">
                <el-input type="text" placeholder="Champ de recherche"/>
            </el-form-item>

            <el-form-item label="Recherche 2">
                <el-input type="text" placeholder="Champ de recherche 2"/>
            </el-form-item>

            <template v-slot:more>
                <el-form-item label="Champ de recherche avancée">
                    <el-input placeholder="Champ de recherche"/>
                </el-form-item>
            </template>
        </ubi-search-container>
    </ubi-panel>
    ```
</docs>
